import { Code2 } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatures from '../../components/services/sections/ServiceFeatures';
import ServiceBenefits from '../../components/services/sections/ServiceBenefits';
import ServiceSteps from '../../components/services/sections/ServiceSteps';
import { colors } from '../../styles/theme';

const features = [
  {
    iconName: 'Terminal',
    title: 'Codex',
    description: 'Un abonnement Plus standard pour coder, corriger, expliquer et accélérer vos projets.'
  },
  {
    iconName: 'Bot',
    title: 'Claude Code',
    description: 'Un accès Plus standard pour travailler dans votre terminal et avancer sur votre code.'
  },
  {
    iconName: 'ShieldCheck',
    title: 'Abonnement Plus',
    description: 'L’offre concerne un abonnement Plus normal, pris en charge par France Student.'
  },
  {
    iconName: 'GraduationCap',
    title: 'Réservé aux étudiants',
    description: 'Votre compte France Student et votre statut étudiant doivent être validés.'
  },
  {
    iconName: 'GitPullRequest',
    title: 'Projet concret',
    description: 'Open source, projet scolaire, associatif ou personnel utile : expliquez votre usage.'
  },
  {
    iconName: 'HeartHandshake',
    title: 'Attribution manuelle',
    description: 'Chaque demande est vérifiée selon les disponibilités et les règles du programme.'
  }
];

const benefits = [
  {
    value: '100%',
    label: 'Pris en charge pour les étudiants sélectionnés'
  },
  {
    value: '1 choix',
    label: 'Codex ou Claude Code, selon votre besoin'
  },
  {
    value: 'Plus',
    label: 'Un abonnement standard, selon disponibilité'
  }
];

const steps = [
  {
    title: 'Inscrivez-vous sur FRANCE STUDENT',
    description: 'Créez votre compte étudiant ou connectez-vous à votre espace client.'
  },
  {
    title: 'Vérifiez votre statut étudiant',
    description: 'Téléchargez votre carte étudiante ou certificat de scolarité.'
  },
  {
    title: 'Déposez votre demande',
    description: 'Choisissez Codex ou Claude Code et indiquez le projet pour lequel vous souhaitez l’utiliser.'
  }
];

const requirements = [
  'Être étudiant et disposer d’un compte France Student actif.',
  'Avoir un statut étudiant validé sur la plateforme.',
  'Choisir un seul outil : Codex ou Claude Code.',
  'Présenter un usage sérieux : projet de cours, open source, association, prototype ou apprentissage.',
  'Accepter que l’attribution dépende des disponibilités et des conditions des plateformes.'
];

const CodePlusPage = () => {
  const handleOrder = () => {
    window.location.href = 'https://fs.fr/oss';
  };

  return (
    <div>
      <ServiceHeader
        title="Codex / Claude Code"
        description="Codex ou Claude Code, en abonnement Plus standard pris en charge par France Student."
        icon={<Code2 className="w-8 h-8 text-white" />}
        color={colors.primary}
        imageUrl="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&q=80"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <ServiceFeatures
          title="Ce qui est inclus"
          features={features}
          color={colors.primary}
        />

        <ServiceBenefits
          title="Avantages du programme"
          benefits={benefits}
          color={colors.primary}
        />

        <section className="mb-16">
          <h2 className="text-2xl font-bold mb-8">Qui peut demander ?</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-semibold mb-4">Critères d’éligibilité</h3>
                <ul className="space-y-3 text-gray-600">
                  {requirements.map((requirement) => (
                    <li key={requirement}>• {requirement}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Important</h3>
                <p className="text-gray-600 mb-4">
                  Cette page présente un programme France Student indépendant. OpenAI, Codex, Anthropic et Claude Code sont des marques de leurs propriétaires respectifs.
                </p>
                <p className="text-gray-600">
                  L’offre correspond à un abonnement Plus standard, sous réserve de validation.
                </p>
              </div>
            </div>
          </div>
        </section>

        <ServiceSteps
          title="Comment en bénéficier"
          steps={steps}
          color={colors.primary}
          ctaText="Demander mon abonnement Plus"
          onCtaClick={handleOrder}
        />
      </div>
    </div>
  );
};

export default CodePlusPage;
